/**
 * Root Reducer
 * Combines all app reducers
 */

const initialState = {
  language: localStorage.getItem('certage_language') || 'en',
  debugEnabled: process.env.REACT_APP_DEBUG === 'true',
  remoteDebugEnabled: process.env.REACT_APP_REMOTE_DEBUG === '1',
  currentPage: window.location.pathname,
  sessionId: null,
  verificationState: null,
};

const ROOT_ACTIONS = {
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_SESSION_ID: 'SET_SESSION_ID',
  SET_VERIFICATION_STATE: 'SET_VERIFICATION_STATE',
  LOG_EVENT: 'LOG_EVENT',
};

export { ROOT_ACTIONS };

export const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case ROOT_ACTIONS.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case ROOT_ACTIONS.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case ROOT_ACTIONS.SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload,
      };
    case ROOT_ACTIONS.SET_VERIFICATION_STATE:
      return {
        ...state,
        verificationState: action.payload,
      };
    case ROOT_ACTIONS.LOG_EVENT:
      // This is handled by middleware, not the reducer
      return state;
    default:
      return state;
  }
};